import React, { useContext, useState } from "react";
import "./ProductDisplay.css";
import star_icon from "../Assets/Frontend_Assets/star_icon.png";
import star_dull_icon from "../Assets/Frontend_Assets/star_dull_icon.png";
import { ShopContext } from "../../Context/ShopContext";

const ProductDisplay = (props) => {
  const { product } = props;
  const { addToCart } = useContext(ShopContext);

  const [showMsg, setShowMsg] = useState(false);

  if (!product) return <div>Loading product...</div>;

  // 🔑 Image path fix for public/images
  const imagePath = product.image.startsWith("/images/")
    ? product.image
    : `/images/${product.image}`;

  const handleAddToCart = () => {
    addToCart(product.id);
    setShowMsg(true);

    setTimeout(() => {
      setShowMsg(false);
    }, 2000);
  };

  return (
    <div className="productdisplay">
      {/* 🔔 Notification */}
      {showMsg && (
        <div className="cart-notification">
          ✅ Product added to cart
        </div>
      )}

      <div className="productdisplay-left">
        <div className="productdisplay-img-list">
          <img src={imagePath} alt={product.name} />
          <img src={imagePath} alt={product.name} />
          <img src={imagePath} alt={product.name} />
          <img src={imagePath} alt={product.name} />
        </div>

        <div className="productdisplay-img">
          <img
            className="productdisplay-main-img"
            src={imagePath}
            alt={product.name}
            onError={(e) => {
              e.target.src = "/images/placeholder.png";
            }}
          />
        </div>
      </div>

      <div className="productdisplay-right">
        <h1>{product.name}</h1>

        <div className="priductdisplay-right-star">
          <img src={star_icon} alt="star" />
          <img src={star_icon} alt="star" />
          <img src={star_icon} alt="star" />
          <img src={star_icon} alt="star" />
          <img src={star_dull_icon} alt="star" />
          <p>(122)</p>
        </div>

        <div className="productdisplay-right-prices">
          <div className="productdisplay-right-price-old">
            £{product.old_price}
          </div>
          <div className="productdisplay-right-price-new">
            £{product.new_price}
          </div>
        </div>

        <div className="productdisplay-right-description">
          {product.description || "No description available"}
        </div>

        <button onClick={handleAddToCart}>ADD TO CART</button>
      </div>
    </div>
  );
};

export default ProductDisplay;
